function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.765,1.379 L1.525,11.683 L0.108,18.163 C0.195,19.553 1.49,20.791 2.446,20.488 L8.959,19.79 L19.215,8.759 C19.975,7.994 19.972,6.762 19.207,6.1 L14.553,1.371 C13.782,0.605 12.531,0.608 11.765,1.379 ZM3.985,18.371 L2.235,16.633 L3.128,12.554 L8.83,17.484 L3.985,18.371 Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 21"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/edit-pencil.a1412cd1.svg";
export { SvgComponent as ReactComponent };